<template>
  <div class="backup-container">
    <b-modal ref="createBackupModal" modal-class="backup-container" size="lg custom-overlay-sm" :centered="true" :lazy="true" :hide-footer="true" @shown="setIntialState" no-fade>
      <div slot="modal-header">
        <div class="float-left modal-title">Create A New Backup</div>
        <!-- <b-btn size="sm" class="float-right" variant="flat" @click="closeModal"> -->
          <close-icon class="icon-default close modalclose " @click="closeModal"></close-icon>
        <!-- </b-btn> -->
      </div>
      <div class="w-100">
        <!-- <div class="custom-tab"> -->
          <div class="custom-tab-header">
            <div class="step-form">
              <ul>
                <li>
                  <b-btn variant="multistep" v-bind:class="{active:activeTab==='siteSelector',completed:activeTab !='siteSelector'}" @click="gotoTab('siteSelector')"><span class="step-count">1</span>Select Websites <tick-simple class="tick-simple" v-if="activeTab !='siteSelector'"></tick-simple></b-btn>
                </li>
                <li>
                  <span class="line"></span>
                </li>
                <li>
                  <b-btn variant="multistep" v-bind:class="{active:activeTab==='details',completed:activeTab =='repository', empty:activeTab==='siteSelector'}" @click="gotoTab('details')" :disabled="$v.sites.$invalid"><span class="step-count">2</span>Enter Details <tick-simple class="tick-simple" v-if="activeTab =='repository'"></tick-simple></b-btn>
                </li>
                <li v-if="isHavingBackupRepository">
                  <span class="line"></span>
                </li>
                <li v-if="isHavingBackupRepository">
                  <b-btn variant="multistep" v-bind:class="{final:activeTab==='repository'}"><span class="step-count">3</span>Select Repository</b-btn>
                </li>
              </ul>
            </div>
          </div>
          <div class="custom-tab-body hasfooter">
            <div v-if="activeTab === 'siteSelector'" class="flex-column h-100">
              <div class="custom-tab-body-cont full-height">
                <site-selector :selected.sync="sites" :noheader="true"></site-selector>
              </div>
              <div class="custom-tab-body-footer">
                <div class="text-right">
                  <b-button type="button" variant="primary" @click="activeTab='details'" :disabled="$v.sites.$invalid">Enter Details<right-arrow-icon class="icon-default right-arrow"></right-arrow-icon></b-button>
                </div>
              </div>
            </div>
            <div v-else-if="activeTab ==='details'" class="flex-column h-100">
              <div class="custom-tab-body-cont full-height">
                <b-form class="backup-form">
                  <b-row>
                    <b-col class="left-col">
                      <b-form-group id="exampleInputGroup1" label="Backup name" label-for="backupname">
                        <b-form-input id="backupname" type="text" v-model="form.backupName" required placeholder="">
                        </b-form-input>
                      </b-form-group>
                      <b-form-group id="exampleInputGroup1" label="No of backups to keep" label-for="noofbackups">
                        <b-btn class="test-minus" variant="flat" @click="decrementLimit">-</b-btn>
                        <b-form-input id="noofbackups" type="text" v-model="form.limit" required placeholder=""></b-form-input>
                        <b-btn variant="flat" @click="incrementLimit">+</b-btn>
                      </b-form-group>
                      <div v-if="$route.params.type==='schedule'">
                        <b-form-group id="exampleInputGroup1" label="When" label-for="when">
                          <b-form-radio-group button-variant="outline-primary" buttons v-model="form.when" :options="whenToBackup" class="active"></b-form-radio-group>
                        </b-form-group>
                      </div>
                      <b-form-group id="options">
                        <b-form-checkbox v-model="form.disableCompression" v-if="form.mechanism !='advancedBackup'">Create zip without compression</b-form-checkbox>
                        <b-form-checkbox class="mt-2" v-model="form.optimizeDB" v-if="form.mechanism=='singleCall'">Optimize database tables before backup</b-form-checkbox>
                      </b-form-group>
                    </b-col>
                    <b-col class="right-col">
                      <b-form-group id="exampleInputGroup1" label="What?" label-for="what" class="mode-group">
                        <b-form-radio-group button-variant="outline-custom" buttons v-model="form.what" :options="whatToBackup" class="active"></b-form-radio-group>
                      </b-form-group>
                      <div v-if="form.what!='db'">
                        <div class="d-flex">
                          <b-form-group label="Exclude files & folders" label-for="excludefiles" class="w-50 px-1 mode-group">
                            <b-form-input id="excludefiles" type="text" v-model="form.exclude" required placeholder="wp-admin,wp-content,old-backup.zip">
                            </b-form-input>
                          </b-form-group>
                          <b-form-group label="Exclude files of these extensions" label-for="exclude extensions" class="w-50 mode-group px-1">
                            <b-form-input id="exclude extensions" type="text" v-model="form.excludeExtensions" required placeholder="e.g. .zip, .mp4">
                            </b-form-input>
                          </b-form-group>
                        </div>
                          <div id="options" class="d-flex mode-group">
                            <b-form-checkbox v-model="isExcludeFileSize">Exclude files greater than</b-form-checkbox>
                            <b-form-select :disabled="!isExcludeFileSize" v-model="excludeFileSize" :options="excludeFileSizeOptions" class="exclude-size" />
                          </div>
                          <b-form-group label="Include folders" label-for="includefolders" class="mode-group">
                            <b-form-input id="includefolders" type="text" v-model="form.include" required placeholder="">
                            </b-form-input>
                          </b-form-group>
                      </div>
                      <b-form-group id="exampleInputGroup1" label-for="what">
                        <label>Backup Method <a class="help-link" :href="seeInstructionURL" target="_blank">What's this?</a></label>
                        <b-form-radio-group button-variant="outline-custom" buttons v-model="form.mechanism" :options="backupMechanism" class="Cctive"></b-form-radio-group>
                      </b-form-group>
                      <b-form-group id="options" label="Enable optimum memory for (use when your backup fails)" label-for="what"  v-if="form.mechanism=='singleCall'">
                        <div class="d-flex">
                          <b-form-checkbox v-model="form.failSafeFiles">Files</b-form-checkbox>
                          <b-form-checkbox class="ml-2" v-model="form.failSafeDB">DB</b-form-checkbox>
                        </div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
              <div class="custom-tab-body-footer">
                <div class="text-right">
                  <b-button type="button" v-if="isHavingBackupRepository" variant="primary" @click="activeTab='repository'">Select repository<right-arrow-icon class="icon-default right-arrow"></right-arrow-icon></b-button>
                  <b-button type="button" v-if="!isHavingBackupRepository" variant="primary" @click="backupNow">Backup Now</b-button>
                </div>
              </div>
            </div>
            <div v-else-if="activeTab ==='repository'" class="flex-column h-100">
              <div class="custom-tab-body-cont full-height">
                <b-form class="backup-form d-flex justify-content-center pt-4">
                  <div>
                    <label>Where to backup?</label>
                    <b-form-group id="exampleInputGroup1" label-for="where" class="mode-group">
                      <b-form-radio-group button-variant="outline-custom" buttons v-model="form.backupRepoType" :options="backupRepoTypes" class="active"></b-form-radio-group>
                    </b-form-group>
                    <div v-if="form.backupRepoType !='iwp_server'">
                      <component v-if="isHavingBackupRepository" :is="currentComponent" :config.sync="cloudConfig" :updateProfileParams.sync="updateProfileParams" :type="form.backupRepoType" :mechanism="form.mechanism" :isRefreshProfile="isRefreshProfile"></component>
                      <span v-else>backup repository promo message will come here</span>
                    </div>
                    <div v-else class="p-2 text-center">
                      Backups will be stored in the server where WP is installed under <br><strong>wp-content/infinitewp/backups</strong>
                    </div>
                  </div>

                </b-form>
                <div class="repo-footer" v-if="this.form.backupRepoType != 'iwp_server'">
                  <div class="d-flex align-items-center" v-if="this.form.backupRepoType != 'iwp_dropbox' && this.form.backupRepoType != 'iwp_gdrive'">
                    <b-form-input id="ftp_create_profile" class="custom-secondary-input" type="text" v-model="createProfileName" required placeholder="profile name">
                    </b-form-input>
                    <b-btn variant="outline-secondary" class="ml-4 custom-secondary-btn" v-on:click="createProfile()"> Create
                       <spinner size="small" v-if="buttonLoaders.createProfile" ></spinner>
                    </b-btn>
                    <div @click="updateProfile()">
                        <floppy class="icon-floppy" v-b-tooltip.hover title="Update profile" v-if="updateProfileParams" ></floppy>
                        <spinner size="small" class="update-loading" v-if="buttonLoaders.updateProfile" ></spinner>
                    </div>
                  </div>
                  <div class="info" v-if="this.form.backupRepoType == 'iwp_dropbox'">Backups will be stored at "Apps/InfiniteWP" in your Dropbox account.</div>
                  <div class="info" v-if="this.form.backupRepoType == 'iwp_gdrive'">Backups will be stored at "InfiniteWP" in your GDrive account.</div>
                  <div class="float-right">
                    <b-btn variant="link" class="repo-test-connection" v-on:click="testConnection()"  :disabled='buttonLoaders.isTestConnectionProgress'>
                      <stetho-scope class="icon-default"></stetho-scope> Test Connection
                      <spinner size="small" v-if="buttonLoaders.isTestConnectionProgress"></spinner>
                    </b-btn>
                  </div>
                </div>
              </div>
              <div class="custom-tab-body-footer">
                <div class="text-right">
                  <b-button type="button" variant="primary" @click="backupNow">Backup Now</b-button>
                </div>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </div>

    </b-modal>
  </div>
</template>

<script>
import CloseIcon from '../../assets/close.svg';
import SiteSelector from '../Common/SiteSelector';
import Close from '../../assets/close1.svg';
import Floppy from '../../assets/floppy.svg';
import StethoScope from '../../assets/stethoscope.svg'
import TickSimple from '../../assets/ticksimple.svg'
import RightArrowIcon from '../../assets/rightarrow.svg';
import { required, minLength } from 'vuelidate/lib/validators';
import _ from "lodash";
export default {
  name: 'CreateBackup',
  props: ['siteId'],
  components: {
    SiteSelector,
    Close,
    Floppy,
    StethoScope,
    CloseIcon,
    RightArrowIcon,
    TickSimple,
    ftprepo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ FTPRepo }) => FTPRepo
      ),
    amazons3repo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ AmazonS3Repo }) => AmazonS3Repo
      ),
    dropboxrepo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ DropboxRepo }) => DropboxRepo
      ),
    gdriverepo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ GdriveRepo }) => GdriveRepo
      )
  },
  data() {
    return {
      activeTab: 'siteSelector',
      showRepository: false,
      currentComponent: null,
      sites: [],
      isExcludeFileSize: false,
      excludeFileSize: '10',
      form: {
        backupName: '',
        limit: 5,
        include: '',
        disableCompression: true,
        optimizeDB: false,
        fileexclusions: '',
        backupRepoType: 'iwp_server',
        mechanism: 'multiCall',
        what: 'full',
        when: 'daily',
        failSafeDB: false,
        failSafeFiles: false
      },
      cloudConfig:{},
      whenToBackup: [
        { text: 'Daily', value: 'daily' },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Fortnightly', value: 'fortnightly' },
        { text: 'Monthly', value: 'monthly' }
      ],
      whatToBackup: [
        { text: 'Files & DB', value: 'full' },
        { text: 'DB', value: 'db' },
        { text: 'Files', value: 'files' }
      ],
      backupMechanism: [
        { text: 'Single call', value: 'singleCall' },
        { text: 'Multi call', value: 'multiCall' },
        { text: 'Phoenix (Beta)', value: 'advancedBackup' }
      ],
      backupRepoTypes: [
        { text: 'WP Server', value: 'iwp_server' },
        { text: 'FTP', value: 'iwp_ftp' },
        { text: 'Amazon S3', value: 'iwp_amazon_s3' },
        { text: 'Dropbox', value: 'iwp_dropbox' },
        { text: 'Google Drive', value: 'iwp_gdrive' }
      ],
      excludeFileSizeOptions: [
        { value: '10', text: '10MB' },
        { value: '50', text: '50MB' },
        { value: '100', text: '100MB' },
        { value: '200', text: '200MB' }
      ],
      config: {},
      createProfileName: "",
      buttonLoaders:{
        createProfile:false,
        updateProfile:false,
        isTestConnectionProgress: false
      },
      updateProfileParams: false,
      isRefreshProfile: false,
    };
  },
  validations: {
    sites: {
      required
    }
  },
  computed: {
    backupType() {
      return this.form.backupRepoType;
    },
    isHavingBackupRepository() {
      let installedAddons = this.$store.getters.getInstalledAddons;
      return _.indexOf(installedAddons,'backupRepository') > -1;
    },
    installedAddons() {
      return this.$store.getters.installedAddons;
    },
    seeInstructionURL() {
      let supportURL = this.$store.getters.getAppInfo.SUPPORT_URL;
      let ga = this.$store.getters.getAppInfo.GA_HELP_TRACKING;
      return supportURL+'solution/articles/227713-how-to-create-api-details-on-your-dropbox-account/'+ga;
    },
  },
  watch: {
    backupType(newType, oldType) {
      switch (newType) {
        case 'iwp_ftp':
          this.currentComponent = 'ftprepo';
          break;
        case 'iwp_amazon_s3':
          this.currentComponent = 'amazons3repo';
          break;
        case 'iwp_dropbox':
          this.currentComponent = 'dropboxrepo';
          break;
        case 'iwp_gdrive':
          this.currentComponent = 'gdriverepo';
          break;
      }
    },
    sites(newValue) {}
  },
  methods: {
    setIntialState() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.sites = [];
      if (this.siteId) {
        this.sites = [this.siteId];
        this.activeTab = 'details';
      }
    },
    incrementLimit() {
      this.form.limit = this.form.limit + 1;
    },
    decrementLimit() {
      if (this.form.limit > 0) {
        this.form.limit = this.form.limit - 1;
      }
    },
    gotoTab(tab) {
      this.activeTab = tab;
    },
    backupNow() {
      let selectedSiteIds = this.sites;
      let payload = {};
      payload.action = 'backup';
      payload.args = {};
      payload.args.siteIDs = selectedSiteIds;
      payload.args.params = {};
      payload.args.params.action = 'now';
      payload.args.params.config = {};
      if (this.isExcludeFileSize) {
        this.form.excludeFileSize = this.excludeFileSize;
      }
      payload.args.params.config = this.form;
      payload.requiredData = {
        getSitesBackupsV3: 1
      };

      if (this.form.backupRepoType != "iwp_server") {
        payload.args.params.accountInfo = {};
        payload.args.params.accountInfo[this.form.backupRepoType] = this.cloudConfig;
      }
      this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          this.$refs.createBackupModal.hide();
        })
        .catch(err => {});
    },
    closeModal() {
      this.$refs.createBackupModal.hide();
    },
    testConnection() {
      let payload = {};
      payload.requiredData = {};
      if (this.form.backupRepoType == 'iwp_dropbox') {
        payload.requiredData.backupRepositoryDropbox = {};
        payload.requiredData.backupRepositoryDropbox[this.form.backupRepoType] = this.cloudConfig;
      }else{
        payload.requiredData.repositoryTestConnection = {};
        payload.requiredData.repositoryTestConnection[this.form.backupRepoType] = this.cloudConfig;
      }
      this.buttonLoaders.isTestConnectionProgress = true;
      this.$store.dispatch("sendAction", payload).then(response => {
        let msg = '';
        if (this.form.backupRepoType == 'iwp_dropbox') {
          msg = response.data.backupRepositoryDropbox;
        }else{
          msg = response.data.repositoryTestConnection;
        }
        this.buttonLoaders.isTestConnectionProgress = false;
        if (msg.status == 'error') {
          window.eventHub.$emit('sendNotification', {
            notifications: [{
              group: 'foo',
              title: 'Test connection',
              type: 'E',
              message: msg.errorMsg,
              delay:-1
            }
            ]
          });
        }else{
          window.eventHub.$emit('sendNotification', {
            notifications: [{
              group: 'foo',
              title: 'Test connection',
              type: 'N',
              message: "Successfully Connected",
              delay:-1
            }
            ]
          });
        }
      });
    },
    createProfile(){
        let params = {
          requiredData: {
            backupRepositorySaveProfile: {},
            backupRepositoryGetAllProfiles: {},
          }
        };
        this.buttonLoaders.createProfile = true;
        params.requiredData.backupRepositorySaveProfile.type= this.form.backupRepoType;
        params.requiredData.backupRepositorySaveProfile.profileName= this.createProfileName;
        params.requiredData.backupRepositorySaveProfile.accountInfo= this.cloudConfig
        this.$store.dispatch("sendAction", params).then(response => {
            this.buttonLoaders.createProfile = false;
            this.isRefreshProfile = true;
        });
    },
    updateProfile(){
      let params = {
        requiredData: {
          backupRepositorySaveProfile: {},
          backupRepositoryGetAllProfiles: {},
        }
      };
      this.buttonLoaders.updateProfile = true;
      params.requiredData.backupRepositorySaveProfile.type= this.form.backupRepoType;
      params.requiredData.backupRepositorySaveProfile.profileName= this.updateProfileParams.profileName;
      params.requiredData.backupRepositorySaveProfile.accountInfo= this.cloudConfig;
      params.requiredData.backupRepositorySaveProfile.repositoryID= this.updateProfileParams.selectedID;
      this.$store.dispatch("sendAction", params).then(response => {
          let profile = response.data.backupRepositoryGetAllProfiles;
          this.buttonLoaders.updateProfile = false;
      });
    },
  }
};
</script>

<style scoped lang="scss">
.create-backup-form {
  width: 100%;
  margin: auto;
  padding: 11px;
}
#noofbackups {
  width: 40px;
  display: inline;
}
// .backup-container {
//   /deep/ .modal-backdrop.show {
//     display: none;
//   }
// }
</style>
